import { useRef } from 'react';
import { classIf, getToolTipDesc, hideTooltip, showMatchDesc, showTooltip } from '../data/utils';
import { isOddUnderMinValue, useOddData } from './OddWrapper';
import { useHighlightOddChange } from './useHighlightOddChange';

export default function Odd(props) {
    const oddContainer = useRef(null);
    
    useHighlightOddChange(oddContainer, props.value, props.matchData.isLive);
    
    const [desc, selected, addBet] = useOddData(props);
    
    function handleMouseOver() {
        const c = oddContainer.current;
        if (c == null) {
            return;
        }

        if (c.oddUniqueId !== props.uniqueId) {
            const t = getToolTipDesc(props);
            c.oddUniqueId = props.uniqueId;
            c.tooltipDesc = t;
        }
        showTooltip(c, c.tooltipDesc);
    }
    function handleOnMouseOut() {
        hideTooltip();
    }

    let classes = '';
    try {
        if (selected) {
            classes += 'selezionata';
        } else if (props.highlighted) {
            classes += ' odd-highlighted';
        } else if (props.disabled) {
            classes += ' odd-disabled';
        }
        if (props.betData.pClass != null) {
            classes += ' ' + props.betData.pClass;
        }
    } catch (e) {
        console.error(e);
    }
    
    let matchDesc = null;
    if ((props.tooltip || props.tooltipByHandicap) && !props.isLastMinute && showMatchDesc(props)) {
        matchDesc = getToolTipDesc(props);
    }

        function getHighlightClass(betId) {
        return betId && betId < 0 ? 'odd-maggiorata ' : '';
    }
    
    return (
        <>
            {matchDesc ?
                <>
                    {props.value == null || isOddUnderMinValue(props.rawValue) ?
                        <div ref={oddContainer} className={"contenitoreSingolaQuota quotaSingolaConNomeSquadra bordo-tondo mx-1" + classIf(props.disabled, 'odd-disabled')}>
                            <p className="titoloQuotazione text-uppercase grigio mb-1">
                                {matchDesc}
                            </p>
                            <p className="tipoQuotazione_1"><i className="fa fa-lock"></i></p>
                        </div>
                        :
                        <div className={"contenitoreSingolaQuota quotaSingolaConNomeSquadra bordo-tondo mx-1 " + classes} ref={oddContainer} onMouseOver={handleMouseOver} onMouseOut={handleOnMouseOut} onClick={addBet}>
                            <p className="titoloQuotazione text-uppercase grigio mb-1">
                                {matchDesc}
                            </p>
                            <p className="tipoQuotazione_1 d-flex flex-column">
                                <span>{matchDesc}</span>
                                {props.value}
                            </p>
                        </div>
                    }
                </>
                :
                <>
                    {props.value == null || isOddUnderMinValue(props.rawValue) ?
                        <div ref={oddContainer} className={"contenitoreSingolaQuota bordo-tondo mx-1" + classIf(props.disabled, 'odd-disabled')}>
                            <p className="titoloQuotazione text-uppercase grigio mb-1">
                                {desc}
                            </p>
                            <p className="tipoQuotazione_1"><i className="fa fa-lock"></i></p>
                        </div>
                        :
                        <div className={`contenitoreSingolaQuota bordo-tondo mx-1 ${getHighlightClass(props?.betId)} ${classes}`} ref={oddContainer} onMouseOver={handleMouseOver} onMouseOut={handleOnMouseOut} onClick={addBet}>
                            <p className="titoloQuotazione text-uppercase grigio mb-1">
                                {desc}
                            </p>
                            <p className="tipoQuotazione_1">{props.value}</p>
                        </div>
                    }
                </>
            }
        </>
    );
}
